
import {Component, Vue, Watch} from "vue-property-decorator";
import {routeMap, routeMaps} from "@/functions/routeMap";
import {withUtm} from "@/functions/formedgeLink";

// #268 リニューアル共通ヘッダー
// 磨りガラスの固定バー+日本語ラベルの水平ナビ。モバイルはフルスクリーンドロワー
@Component
export default class SiteHeader extends Vue {
  // デスクトップナビ(セキュリティポリシーはフッター掲載のため除外)
  private navItems = [
    routeMap.home,
    routeMap.service,
    routeMap.message,
    routeMap.culture,
    routeMap.recruit,
    routeMap.access,
  ];

  // モバイルドロワーは全ページ掲載
  private allNavItems = routeMaps;

  private drawer = false;
  private scrolled = false;

  mounted(): void {
    window.addEventListener("scroll", this.onScroll, {passive: true});
    this.onScroll();
  }

  beforeDestroy(): void {
    window.removeEventListener("scroll", this.onScroll);
  }

  private onScroll(): void {
    this.scrolled = window.scrollY > 8;
  }

  // 外部リンクには流入元計測用の UTM を付与（全ページ共通のナビなので campaign は "common"）
  private externalLink(url: string, content: string): string {
    return withUtm(url, "common", content);
  }

  private isActive(path: string): boolean {
    return this.$route.path === path;
  }

  // ページ遷移したらドロワーを閉じる(戻る/進む対策)
  @Watch("$route")
  private onRouteChange(): void {
    this.drawer = false;
  }
}
